var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 15.9167V14.2871C14.2501 13.4227 13.8989 12.5937 13.2738 11.9824C12.6486 11.3712 11.8008 11.0278 10.9167 11.0278H4.25008C3.36603 11.0278 2.51818 11.3712 1.89306 11.9824C1.26794 12.5937 0.916748 13.4227 0.916748 14.2871V15.9167",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 7.76852C9.42428 7.76852 10.9167 6.3093 10.9167 4.50926C10.9167 2.70922 9.42428 1.25 7.58333 1.25C5.74238 1.25 4.25 2.70922 4.25 4.50926C4.25 6.3093 5.74238 7.76852 7.58333 7.76852Z",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.9168V14.2871C19.2494 13.565 19.0036 12.8635 18.5511 12.2927C18.0986 11.722 17.4651 11.3143 16.75 11.1338",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 1.35596C14.1338 1.53546 14.7693 1.94319 15.2231 2.51488C15.6769 3.08656 15.9233 3.78967 15.9233 4.51336C15.9233 5.23706 15.6769 5.94017 15.2231 6.51185C14.7693 7.08353 14.1338 7.49127 13.4167 7.67077",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staff_icon.32d46c8b728a5ad96dff88004f73c66f.svg";
export { ForwardRef as ReactComponent };